import { object, number, string, create } from 'superstruct'

export const CreateParams = object({
  id: number(),
  name: string()
})

export class Belt {
  static create(params) {
    return new Belt(create(params, CreateParams))
  }

  constructor(params) {
    Object.assign(this, params)
  }
}
